import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Banner displayed at the top of pages when user account is suspended.
 * Shows read-only mode warning and link to suspension details.
 */
const ReadOnlyBanner = ({ reason }) => {
  return (
    <div className="bg-red-50 border-b border-red-200">
      <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between flex-wrap">
          <div className="w-0 flex-1 flex items-center">
            <span className="flex p-2 rounded-lg bg-red-100">
              <svg
                className="h-5 w-5 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </span>
            <p className="ml-3 font-medium text-red-700 truncate">
              <span className="md:hidden">Account suspended - Read-only mode</span>
              <span className="hidden md:inline">
                Your account is suspended. You are viewing your data in read-only mode.
                {reason && (
                  <span className="text-red-600 ml-1">
                    Reason: {reason}
                  </span>
                )}
              </span>
            </p>
          </div>
          <div className="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
            <Link
              to="/account-suspended"
              className="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-red-600 bg-white hover:bg-red-50"
            >
              Learn more
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyBanner;
